import React from "react";
import { Box, Chip, Divider, MenuItem, Stack, TextField, Typography } from "@mui/material";
import BadgeIcon from "@mui/icons-material/Badge";
import { ATTENDANCE_QUICK_PRESETS, DEFAULT_ATTENDANCE_STATE } from "./attendanceFilterConfig";

/**
 * Smart HR filters shown only for the "Wins Attendance" collection.
 */
export default function AttendanceQuickFilters({ state, onChange, distinctFor }) {
  const s = { ...DEFAULT_ATTENDANCE_STATE, ...(state || {}) };
  const set = (patch) => onChange({ ...s, ...patch });

  const applyPreset = (preset) => onChange(preset.build());

  const deviceOptions = distinctFor ? distinctFor("device") : [];
  const branchOptions = distinctFor ? distinctFor("branch") : [];

  return (
    <Box>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <BadgeIcon fontSize="small" color="primary" />
        <Typography variant="subtitle2" color="primary">
          Attendance Quick Filters
        </Typography>
        <Chip size="small" color="primary" variant="outlined" label="Wins Attendance" />
      </Stack>

      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ mb: 1.5 }}>
        {ATTENDANCE_QUICK_PRESETS.map((preset) => (
          <Chip
            key={preset.id}
            label={preset.label}
            size="small"
            onClick={() => applyPreset(preset)}
            variant={s.special === preset.id ? "filled" : "outlined"}
            color={s.special === preset.id ? "primary" : "default"}
            clickable
          />
        ))}
      </Stack>

      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        <TextField
          size="small"
          label="Employee ID"
          value={s.employeeId}
          onChange={(e) => set({ employeeId: e.target.value })}
          sx={{ minWidth: 150 }}
        />
        <TextField
          size="small"
          label="Employee Name"
          value={s.employeeName}
          onChange={(e) => set({ employeeName: e.target.value })}
          sx={{ minWidth: 170 }}
        />
        <TextField
          select
          size="small"
          label="Device"
          value={s.device}
          onChange={(e) => set({ device: e.target.value })}
          sx={{ minWidth: 150 }}
        >
          <MenuItem value="">All devices</MenuItem>
          {deviceOptions.map((d) => (
            <MenuItem key={d} value={d}>{d}</MenuItem>
          ))}
        </TextField>
        <TextField
          select
          size="small"
          label="Branch"
          value={s.branch}
          onChange={(e) => set({ branch: e.target.value })}
          sx={{ minWidth: 150 }}
        >
          <MenuItem value="">All branches</MenuItem>
          {branchOptions.map((b) => (
            <MenuItem key={b} value={b}>{b}</MenuItem>
          ))}
        </TextField>
        <TextField
          select
          size="small"
          label="Punch Type"
          value={s.punchType}
          onChange={(e) => set({ punchType: e.target.value })}
          sx={{ minWidth: 130 }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="IN">IN</MenuItem>
          <MenuItem value="OUT">OUT</MenuItem>
        </TextField>
        <TextField
          size="small"
          label="Status"
          value={s.status}
          onChange={(e) => set({ status: e.target.value })}
          sx={{ minWidth: 120 }}
        />
        <Divider orientation="vertical" flexItem />
        <TextField
          type="date"
          size="small"
          label="From Date"
          slotProps={{ inputLabel: { shrink: true } }}
          value={s.fromDate}
          onChange={(e) => set({ fromDate: e.target.value })}
          sx={{ minWidth: 160 }}
        />
        <TextField
          type="date"
          size="small"
          label="To Date"
          slotProps={{ inputLabel: { shrink: true } }}
          value={s.toDate}
          onChange={(e) => set({ toDate: e.target.value })}
          sx={{ minWidth: 160 }}
        />
      </Stack>
    </Box>
  );
}
